import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ===== Suprimir aviso benigno "ResizeObserver loop" =====
// Disparado por componentes Radix UI (Select/Tooltip/etc.) quando dropdowns abrem.
// É um aviso, não um erro funcional. Suprimimos para evitar overlay vermelho do CRA.
if (typeof window !== "undefined") {
  const RESIZE_MESSAGES = [
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop limit exceeded",
  ];
  // 1) Bloquear o evento global "error"
  window.addEventListener("error", (e) => {
    if (e?.message && RESIZE_MESSAGES.some((m) => e.message.includes(m))) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  // 2) Esconder o overlay de erro do react-error-overlay (CRA) para essa mensagem
  const _origConsoleError = window.console.error;
  window.console.error = (...args) => {
    const first = args && args[0];
    const msg = typeof first === "string" ? first : (first?.message || "");
    if (RESIZE_MESSAGES.some((m) => msg.includes(m))) return;
    _origConsoleError.apply(window.console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
